import React from "react"

import Layout from "../components/layout"
import SEO from "../components/seo"

const NotFoundPage = () => (
  <Layout>
    <SEO title="404: Not found" />
    <div className={"flex items-center justify-center w-full h-full absolute top-0 left-0"}>
      <div>
        <h1>404: Not Found</h1>
        <p>You just hit a route that doesn't exist... the sadness.</p>
        <a className={'text-white bg-green-400 px-3 py-1 rounded-full font-bold text-lg'} href="https://www.zoeduby.com">Go back</a>
      </div>
    </div>
  </Layout>
)

export default NotFoundPage
